import React from 'react';
import { bonuses } from '../data/bonuses';
import { OFFER_ANCHOR } from './constants';
export function BonusSection() {
  return <section className="border-y border-brand-line bg-brand-cream px-4 py-5" data-id="element-16" data-mp="1ofc5fttsurgy">
      <div className="mx-auto max-w-4xl" data-id="element-17" data-mp="22ellmti09lkx">
        <div className="mb-2 text-center" data-id="element-18" data-mp="22diuckgrth4h">
          <h2 className="mb-1 font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-19" data-mp="1ydi3g0chjdgj">
            🎁 5 Bonus Premium Inclusi
          </h2>
          <p className="mx-auto max-w-3xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-20" data-mp="1amcnzmagin6r">
            Il tuo accesso comprende anche cinque bonus operativi progettati per aiutarti a
            progettare meglio, scegliere i dispositivi, risolvere problemi, creare automazioni e
            trasformare ciò che hai imparato in progetti reali.
          </p>
        </div>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="qydf6gzgdq3z">
          {bonuses.map(bonus => <a key={bonus.title} href={OFFER_ANCHOR} className="rounded-xl border border-brand-gold/60 bg-white p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-orange" data-id="element-22" data-mp="mymhruff8bqh">
              <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-23" data-mp="2jhcuyvj819zt">
                {bonus.title}
              </h3>
              <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-24" data-mp="2oj26sde9proy">
                {bonus.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}